<template>
  <v-main>
    <div class="max_width_container">
      <breadcrumbs class=" " :items="items"></breadcrumbs>

      <v-row cols="12" class="ma-0 pa-0">
        <v-col class="ma-0 pa-0" cols="12" xs="12" sm="12" md="12" lg="12" xl="12" v-if="combos && combos.length > 0">
          <v-card
              elevation="1"
              class=""
              width="100%"
              v-for="combo in combos"
              :key="combo.id"
          >
            <v-toolbar
                color="#bc0000"
                dark
                elevation="0"
                class="px-4 py-2"
                height="auto"

            >
              <v-row cols="12" class="ma-0 pa-0">
                <v-col class="ma-0 pa-0" cols="12" xs="12" sm="6" md="6" lg="6" xl="6">
                  <p class="title-toolbar">Combo: {{ combo.name }}</p>
                </v-col>
                <v-col class="ma-0 pa-0" cols="12" xs="12" sm="3" md="3" lg="3" xl="3">
                  <p class="title-toolbar">Preço: {{ formatCurrency(combo.price) }}</p>
                </v-col>
                <v-col class="ma-0 pa-0" cols="12" xs="12" sm="3" md="3" lg="3" xl="3">
                  <v-btn
                      v-if="combo.isThereSlots"
                      class="float-right secondary-button btn"
                      elevation="0"
                      :href="generateLink(combo.id)"
                  >
                    Comprar agora
                  </v-btn>
                </v-col>
              </v-row>
              <v-spacer></v-spacer>
            </v-toolbar>

            <v-row
                class="pa-2"
            >

              <v-col
                  cols="12" xs="12" sm="6" md="4" lg="4" xl="4"
                  style="margin-top: -30px!important; margin-bottom: -20px!important;"
                  class="ma-0"
                  v-for="course in combo.combosTOCourses"
                  :key="course.id"
              >
                <Course
                    :key="`${course.id}_course_`"
                    :course="course.course"
                    :showBtnBuy="false"
                    :showBtns="true"
                ></Course>
              </v-col>
            </v-row>
          </v-card>

        </v-col>

        <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12" class="text-center" v-else>
          <h2>Nenhum curso com inscrições abertas!</h2>
        </v-col>
      </v-row>
    </div>
  </v-main>
</template>

<style scoped>
.btn {
  text-transform: none !important;
  font-size: 15px !important;
  margin-right: -2px !important;
  margin-bottom: -15px !important;
}

.title-toolbar {
  font-weight: 500;
  font-size: 18px;
  margin-top: 7px;
}

.max_width_container {
  width: 80% !important;
  margin: 0 10% 0 10%;
}

@media (max-width: 1264px) {
  .max_width_container {
    width: 100% !important;
    margin: 0;
  }
}
</style>

<script>
import ApiService from "../../../services/ApiService";
import FormatParamsUrl from "../../../Utils/FormatParamsUrl";
import Breadcrumbs from "../components/Breadcrumbs.vue";

import Vue from "vue";
import Course from "./Course.vue";
import FormatCurrency from "../../../Utils/FormatCurrency";

export default {
  name: "Combos",

  components: {
    Course,
    Breadcrumbs,
  },

  async mounted() {
    this.baseUrl = window.location.origin
    this.onResize();
    window.addEventListener("resize", this.onResize, {passive: true});
    this.env_url = process.env.VUE_APP_BASE_URL;
  },

  beforeDestroy() {
    if (typeof window !== "undefined") {
      window.removeEventListener("resize", this.onResize, {passive: true});
    }
    this.$root.$off("rechargeSubcategory")
  },

  data: () => ({
    page: 1,
    totalPages: 15,
    totalItems: 0,
    componentKey: 1,
    isMobile: false,
    initalRange: 0,
    finalRange: 0,
    products: [],
    combos: [],
    subCategory: {},
    selected: null,
    env_url: "",
    apiService: new ApiService(),
    title: "",
    meta: [],
    filter: {
      page: 1,
      pageSize: 20,
      productSubCategory: null,
      CategoryName: null,
      productIndicator: null,
      rangePrice: [0, 200],
      product: "",
      selectedSizes: [],
      Subcategories: [],
      orderByPrice: 0,
    },
    items: [],
    baseUrl: null
  }),


  computed: {},

  async created() {
    await this.getCombos()
    this.items = [
      {
        text: "Página Inicial",
        disabled: true,
        href: "/home",
      },
      {
        text: "Cursos",
        disabled: true,
        href: "",
      },
      {
        text: "Combos",
        disabled: false,
        href: "",
      },
    ]
  },

  watch: {},
  methods: {
    formatCurrency(value) {
      return FormatCurrency.formatCurrency(value);
    },

    async getCombos() {
      try {
        const {content} = await this.apiService.get(`combo/active/b2c`,)
        this.combos = content
      } catch (e) {
      }
    },
    onResize() {
      this.isMobile = window.innerWidth < 600;
    },
    generateLink(comboId){
      return `${this.baseUrl}/cursos/combos/checkout/${comboId}`
    },

    async goTo(path) {
      await this.$router.push({
        path,
      });
    },
    async goToCheckout(path, id) {
      await this.$router.push({
        path,
        query: {id, curso_combo: 'combo'}
      });
    },
  },
};
</script>
